import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {ConversationSummaryFactModel} from '../../../../../../libs/shared/core/src/models/api/factModel';
import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {makeSizeConstants} from '../../../../../../libs/shared/ui/src/styles/styleHelpers';

/*
 * Props.
 */

interface ConversationSummaryAiSummarizeProps {
  summary: ConversationSummaryFactModel;
  size?: VisualSizesEnum;
}

/*
 * Style.
 */

export const listSizeConstants = makeSizeConstants(
  css`
    font-size: ${fontSizes.verySmall};
    font-weight: ${fontWeights.normal};
    line-height: 16px;

    > li {
      padding-left: 8px;
    }
  `,
  css`
    font-size: ${fontSizes.medium};
    line-height: 20px;
    font-weight: ${fontWeights.normal};

    > li {
      padding-left: 4px;
    }
  `,
);

const StyledAiSummaryDiv = styled.div`
  display: flex;
  flex-direction: column;
  white-space: pre-wrap;
  margin-top: 4px;

  width: 100%;

  position: relative;

  grid-area: content;
`;

const StyledSummariesList = styled.ul<{$size: VisualSizesEnum}>`
  margin-top: 0px;
  margin-bottom: 4px;
  padding-left: 16px;
  ${(p) => listSizeConstants[p.$size]};

  > li:not(:last-child) {
    margin-bottom: 4px;
  }

  > li::marker {
    font-size: 0.8em;
  }
`;

/*
 * Component.
 */

export const ConversationSummaryAiSummarize: FC<ConversationSummaryAiSummarizeProps> = (props) => {
  const {summary, size = VisualSizesEnum.SMALL} = props;
  return (
    <StyledAiSummaryDiv>
      <StyledSummariesList $size={size}>
        {summary.summary.map((summ) => (
          <li key={`conversation-header-summary-item-${summ}`}>{summ}</li>
        ))}
      </StyledSummariesList>
    </StyledAiSummaryDiv>
  );
};
